export default "__VITE_ASSET__DbihBNrA__"